export default "__VITE_ASSET__BsNN2bwN__"